import Trackers from '../tracker/tracker';

$(function() {
    const trackers = new Trackers();

    $('[name=form_text_3]').mask('+7(999)999-9999');

    $('[name^=form_text_], [name^=form_textarea_], [name^=form_email_]')
        .wrap('<div class="icon-field"></div>')
        .addClass('form__input form__input--shade');

    $('.js-gtm-claim-button').click(function() {
        trackers.onFeedbackSend();
    });
});



// WEBPACK FOOTER //
// ./blocks/claim/claim.js